/** How long the member sees the notice before leaving for the external site. */
export const EXTERNAL_REDIRECT_DELAY_MS = 3000;

interface IRedirectCopy {
  title: string;
  hint: string;
}

const escapeHtml = (value: string) =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

// Same palette as the wallet cards, inlined: the new tab has none of the site's stylesheets.
const noticePage = (url: string, { title, hint }: IRedirectCopy) => `<!doctype html>
<html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1">
<meta name="referrer" content="no-referrer">
<meta http-equiv="refresh" content="${EXTERNAL_REDIRECT_DELAY_MS / 1000};url=${escapeHtml(url)}">
<title>${escapeHtml(title)}</title>
<style>
  html, body { height: 100%; margin: 0; }
  body { display: flex; align-items: center; justify-content: center; padding: 16px; box-sizing: border-box;
    background: #f6f6f6; color: #292929; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
  .card { max-width: 420px; padding: 32px 28px; border: 1px solid #cfe6d1; border-radius: 10px; background: #fff;
    text-align: center; box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05); }
  .spinner { width: 44px; height: 44px; margin: 0 auto 20px; border: 4px solid #e8f5e9; border-top-color: #2e7d32;
    border-radius: 50%; animation: spin 0.9s linear infinite; }
  h1 { margin: 0 0 8px; font-size: 18px; color: #1b5e20; }
  p { margin: 0; font-size: 14px; line-height: 1.45; color: #666; }
  @keyframes spin { to { transform: rotate(360deg); } }
</style></head>
<body><div class="card"><div class="spinner"></div><h1>${escapeHtml(title)}</h1><p>${escapeHtml(hint)}</p></div></body></html>`;

/**
 * Opens an external URL in a new tab after showing a short notice there. The tab is opened right
 * away, inside the click, because a tab opened after a delay is blocked as a popup; the notice page
 * itself redirects when the delay is over, so it does not depend on this page staying open. The tab
 * is detached from this page (opener cleared) and sends no referrer, as rel="noopener noreferrer"
 * would. Returns false when the browser blocked the tab, so the caller can fall back.
 */
export function openExternalWithNotice(url: string, copy: IRedirectCopy): boolean {
  const tab = window.open('', '_blank');
  if (!tab) {
    return false;
  }

  tab.opener = null;
  tab.document.open();
  tab.document.write(noticePage(url, copy));
  tab.document.close();

  return true;
}
